"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
const Api = require("../../Api");
const actions = require("./actions");
const update = (dispatch) => {
    return async (attributes) => {
        dispatch(actions.updateRequest(attributes));
        try {
            const { data: { user: me } } = await Api.client.put('/users/me', { item: attributes });
            dispatch(actions.updateSuccess(me));
        }
        catch (error) {
            dispatch(actions.updateFailure(Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.update = update;
//# sourceMappingURL=operations.js.map